<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <label class="label-input">Style</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <ColorPicker v-model="fields.background" name="background" label="Background" default-color="#ffffff" />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker v-model="fields.textColor" name="text-color" label="Text Color" default-color="#000000" />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox class="mt-0" v-model="fields.topPadding" label="Top Padding" hide-details />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox class="mt-0" v-model="fields.bottomPadding" label="Bottom Padding" hide-details />
              </v-col>
              <v-col cols="12" md="4">
                <ColorPicker
                  v-model="fields.highlightColor"
                  name="highlight-color"
                  label="Highlight Color"
                  default-color="#cb6387"
                />
              </v-col>
              <v-col cols="12">
                <v-switch v-model="fields.enableContainerPage" label="Enable container page" hide-details />
              </v-col>
              <v-col cols="12" v-if="fields.enableContainerPage">
                <ColorPicker
                  v-model="fields.backgroundContainer"
                  name="background-container"
                  label="Container Background"
                  default-color="#ffffff"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Top Block</label>
          <div class="group-item">
            <v-checkbox v-model="fields.showRatedBlock" label="Show Rated Block" hide-details class="mt-0 mb-2" />
            <label class="mb-2 d-block">Rated Content</label>
            <ckeditor :editor="editor" v-model="fields.ratingValue" :config="editorConfig" />
            <v-checkbox v-model="fields.showTitle" label="Show Title" hide-details class="mt-4 mb-2" />
            <label class="mb-2 d-block">Title Content</label>
            <ckeditor :editor="editor" v-model="fields.titleCard" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Product Review Block</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <label class="mb-2 d-block">Product Image</label>
                <UploadImage
                  @callback="obj => (fields.productReview.image = obj.imageSrc)"
                  :image="{ imageSrc: fields.productReview.image }"
                  :height="`120`"
                  :typeUpload="'image'"
                  @callbackDelete="() => (fields.productReview.image = '')"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.productReview.productName" label="Product Name" />
                <v-text-field v-model="fields.productReview.currentPrice" label="Current Price" />
                <v-text-field v-model="fields.productReview.oldPrice" label="Old Price" />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Slider Items</label>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="fields.colPerView"
                  :items="[
                    { value: 1, text: '1' },
                    { value: 2, text: '2' },
                    { value: 3, text: '3' },
                    { value: 4, text: '4' },
                  ]"
                  label="Desktop Slides Per View"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  v-model.number="fields.spaceBetween"
                  type="number"
                  min="0"
                  label="Space Between"
                />
              </v-col>
            </v-row>

            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, index) in fields.listItem" :key="`review-slider-item-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center" style="width: 100%">
                    <span>Item {{ index + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveItem(index)">
                      <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-3">
                    <label class="mb-2 d-block">Review Image</label>
                    <UploadImage
                      @callback="obj => handleUploadReviewImage(obj, index)"
                      :image="{ imageSrc: item.reviewImage }"
                      :height="`220`"
                      :typeUpload="'image'"
                      @callbackDelete="() => handleRemoveReviewImage(index)"
                    />
                  </div>
                  <v-text-field v-model="item.reviewerName" label="Reviewer Name" />
                  <!-- <v-select
                    v-model="item.starValue"
                    :items="[
                      { value: 1, text: '1 star' },
                      { value: 2, text: '2 stars' },
                      { value: 3, text: '3 stars' },
                      { value: 4, text: '4 stars' },
                      { value: 5, text: '5 stars' },
                    ]"
                    label="Stars"
                    outlined
                    dense
                  /> -->
                  <div class="mb-3">
                    <div>Rating</div>
                    <v-rating
                      v-model="item.starValue"
                      length="5"
                      hover
                      color="warning"
                      background-color="#c1c1c1"
                      empty-icon="mdi-star-outline"
                      full-icon="mdi-star"
                    />
                  </div>
                  <label class="mb-2 d-block">Review Content</label>
                  <ckeditor :editor="editor" v-model="item.contentReview" :config="editorConfig" />
                  <v-text-field v-model="item.purchaseDate" label="Purchase Date" class="mt-3" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import ColorPicker from './common/color-picker.vue';

const DEFAULT_REVIEW_IMAGE = 'https://cdn.skyfastimg.com/images/2026/05/07/image-69fbf942b1aec8f61ad7e403.webp';

export default {
  name: 'review-slider-yuri-section-editor',
  components: {
    UploadImage,
    ColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Review Slider Yuri Section',
        enableAnchor: false,
        topPadding: true,
        bottomPadding: true,
        background: '#FFFFFF',
        textColor: '#000000',
        enableContainerPage: false,
        backgroundContainer: '#FFFFFF',
        showRatedBlock: true,
        ratingValue: '<p>Rated <strong>4.9/5</strong> based on 1,200+ reviews</p>',
        showTitle: true,
        titleCard: '<h2>Join Over 10,000+ <i>Happy Customers</i></h2>',
        highlightColor: '#cb6387',
        colPerView: 3,
        spaceBetween: 16,
        productReview: {
          image: '',
          productName: '',
          currentPrice: '',
          oldPrice: '',
        },
        listItem: [],
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
      productReview: {
        ...this.fields.productReview,
        ...(this.sectionEditor.sectionExtract?.productReview || {}),
      },
      listItem: Array.isArray(this.sectionEditor.sectionExtract?.listItem)
        ? this.sectionEditor.sectionExtract.listItem.map(item => ({
            reviewImage: item.reviewImage || '',
            starValue: Math.min(Math.max(parseInt(item.starValue, 10) || 5, 1), 5),
            reviewerName: item.reviewerName || '',
            purchaseDate: item.purchaseDate || '',
            contentReview: item.contentReview || '',
          }))
        : this.fields.listItem,
    };

    if (!this.fields.listItem.length) {
      this.handleAddItem();
    }
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleAddItem() {
      this.fields.listItem.push({
        reviewImage: DEFAULT_REVIEW_IMAGE,
        starValue: 5,
        reviewerName: 'John Doe,30',
        purchaseDate: 'Purchased on October, 2026',
        contentReview:
          '<p>I was skeptical at first but I’m so glad I gave it a chance. This mask made my skin look amazing.</p>',
      });
    },
    handleRemoveItem(index) {
      this.fields.listItem.splice(index, 1);
    },
    handleUploadReviewImage(obj, index) {
      this.fields.listItem[index].reviewImage = obj.imageSrc;
    },
    handleRemoveReviewImage(index) {
      this.fields.listItem[index].reviewImage = '';
    },
    handleSave() {
      const payload = {
        ...this.fields,
        colPerView: Number(this.fields.colPerView) > 0 ? Number(this.fields.colPerView) : 3,
        spaceBetween: Number(this.fields.spaceBetween) >= 0 ? Number(this.fields.spaceBetween) : 16,
        productReview: {
          image: this.fields.productReview?.image || '',
          productName: this.fields.productReview?.productName || '',
          currentPrice: this.fields.productReview?.currentPrice || '',
          oldPrice: this.fields.productReview?.oldPrice || '',
        },
        listItem: (this.fields.listItem || []).map(item => ({
          reviewImage: item.reviewImage || '',
          starValue: Math.min(Math.max(parseInt(item.starValue, 10) || 5, 1), 5),
          reviewerName: item.reviewerName || '',
          purchaseDate: item.purchaseDate || '',
          contentReview: item.contentReview || '',
        })),
      };
      const updateHtml = updateHtmlFromData.sectionReviewSliderYuri(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}

.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}

.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}

.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
